class FreeItem extends HTMLElement {
  constructor() {
    super();
    this.attachEvent();
  }

  attachEvent() {
    setTimeout(() => {
      const freeCleanerButton = document.querySelector("#free-cleaner-button");

      if (freeCleanerButton) {
        freeCleanerButton.replaceWith(freeCleanerButton.cloneNode(true));
        const newFreeCleanerButton = document.querySelector(
          "#free-cleaner-button"
        );

        newFreeCleanerButton.addEventListener("click", function () {
          newFreeCleanerButton.setAttribute("aria-disabled", "true");
          newFreeCleanerButton.classList.add("loading");

          const cleanerProductId = "53921231176028";

          const config = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: cleanerProductId,
              quantity: 1,
            }),
          };

          fetch("/cart/add.js", config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                console.error("❌ Error adding free cleaner:", response);
                return;
              }
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "cart-drawer",
                productVariantId: cleanerProductId,
                cartData: response,
              });
            })
            .catch((e) => console.error("❌ Fetch error:", e))
            .finally(() => {
              newFreeCleanerButton.classList.remove("loading");
              newFreeCleanerButton.removeAttribute("aria-disabled");
              newFreeCleanerButton.parentNode.removeChild(newFreeCleanerButton);
            });
        });
      } else {
        setTimeout(this.attachEvent.bind(this), 1000);
      }
    }, 500);
  }
}

customElements.define("free-item", FreeItem);
